var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5V17.5M4 7.5H20M16.138 21.5H7.858C6.811 21.5 5.941 20.692 5.863 19.647L4.966 7.5H19L18.133 19.642C18.058 20.689 17.187 21.5 16.138 21.5Z",
    stroke: "#979797",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.5L15.987 4.798C15.694 4.017 14.948 3.5 14.114 3.5H9.886C9.052 3.5 8.306 4.017 8.013 4.798L7 7.5M15.43 11.5L15 17.5M8.57 11.5L9 17.5",
    stroke: "#979797",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9f344ed9728e4de69bc16023e0de6f03.svg";
export { ForwardRef as ReactComponent };